function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 8a1 1 0 00-1 1v6H9a1 1 0 100 2h6v6a1 1 0 102 0v-6h6a1 1 0 100-2h-6V9a1 1 0 00-1-1z",
  fill: "#fff"
});

var SvgIconPlusWhite = function SvgIconPlusWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNiA4QzE1LjQ0NzcgOCAxNSA4LjQ0NzcyIDE1IDlWMTVIOUM4LjQ0NzcyIDE1IDggMTUuNDQ3NyA4IDE2QzggMTYuNTUyMyA4LjQ0NzcyIDE3IDkgMTdIMTVWMjNDMTUgMjMuNTUyMyAxNS40NDc3IDI0IDE2IDI0QzE2LjU1MjMgMjQgMTcgMjMuNTUyMyAxNyAyM1YxN0gyM0MyMy41NTIzIDE3IDI0IDE2LjU1MjMgMjQgMTZDMjQgMTUuNDQ3NyAyMy41NTIzIDE1IDIzIDE1SDE3VjlDMTcgOC40NDc3MiAxNi41NTIzIDggMTYgOFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgIconPlusWhite as ReactComponent };